import Vue from 'vue'
import {
  createPlatformState,
  platformAction,
  platformGetters,
  platformMutations
} from '~/helpers/store'

export default {
  state: () => createPlatformState(),
  actions: {
    async fetchMembership ({ commit }) {
      const membership = await platformAction({
        client: this.$api.profiles.memberships,
        method: 'get',
        commit,
        logError: this.$logError,
        commitData: false,
        include: []
      })

      commit('saveMembership', membership)
    },
    async updateMembership ({ commit }, params) {
      const membership = await platformAction({
        client: this.$api.profiles.memberships,
        method: 'update',
        commit,
        params,
        logError: this.$logError,
        commitData: false
      })

      commit('saveMembership', membership)
    },

    setUserOnboardedLocally ({ commit }) {
      commit('setUserOnboardedLocally')
    }
  },
  getters: {
    ...platformGetters,
    membership: s => s.data,
    status: s => s.data.status,
    inducted: s => s.data.inductedAt !== null
  },
  mutations: {
    ...platformMutations,
    saveMembership: (s, membership) => {
      Vue.set(s, 'data', membership)
    },
    setUserOnboardedLocally: s => {
      Vue.set(s.data, 'inductedAt', new Date().toISOString())
    }
  }
}
